export const SECOND = 1000;
export const MINUTE = 60 * SECOND;
export const HOUR = 60 * MINUTE;
export const DAY = 24 * HOUR;
export const MS_PER_DAY = DAY;
export const QUERY_RETRY_ATTEMPTS = 1;

export const COUPON_INFO_STALE_TIME = MINUTE;
export const COUPON_LIST_STALE_TIME = 5 * MINUTE;
export const COUPON_SCOPE_OPTIONS_STALE_TIME = 10 * MINUTE;
export const COUNTRY_MAPPINGS_STALE_TIME = 12 * HOUR;
